import type { FieldPolicy } from "@apollo/client"

export const layerCacheFields: Record<string, FieldPolicy> = {
  getLayerByFeatureCode: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.input?.featureCode) return
      const ref = toReference({
        __typename: "Layer",
        FeatureCode: args.input.featureCode,
      })
      if (ref && canRead(ref)) return ref
    },
  },
}
